<template>
    <div class="Xingji_shuangyi">
        <headerWX class="headerWX"></headerWX>
        <img class="bg" src="@/assets/imgs/Xingji_shuangyi/bg.png" alt="">
        <div class="Xingji_shuangyi_Content">
            <div class="tit">
                <img src="@/assets/imgs/Xingji_shuangyi/tit.png" alt="">
            </div>
            <!-- 宝库 -->
            <div class="Exchange public_btn">
                <img style="cursor: pointer;" @click="openWindow('Exchange')"
                    src="@/assets/imgs/Xingji_shuangyi/Exchange_btn.png" alt="">
            </div>
            <!-- 进阶奖励-->
            <!-- <div class="Advanced public_btn">
                <img style="cursor: pointer;" @click="openWindow('Advanced')"
                    src="@/assets/imgs/Xingji_shuangyi/Advanced_btn.png" alt="">
            </div> -->
            <!-- 规则 -->
            <div class="Rules public_btn">
                <img style="cursor: pointer;" @click="openWindow('Rules')"
                    src="@/assets/imgs/Xingji_shuangyi/Rules_btn.png" alt="">
            </div>
            <!-- 奖池 -->
            <div class="PrizePool public_btn">
                <img style="cursor: pointer;" @click="openWindow('PrizePool')"
                    src="@/assets/imgs/Xingji_shuangyi/PrizePool_btn.png" alt="">
            </div>
            <!-- 规则 -->
            <div class="Record public_btn">
                <img style="cursor: pointer;" @click="openWindow('Record')"
                    src="@/assets/imgs/Xingji_shuangyi/Record_btn.png" alt="">
            </div>



            <!-- 特别奖励 -->
            <div :class="['SpecialReward', 'public_btn', { 'Activate': TotalData.specialChanceAvailable >= 1 }]"
                @click="SpecialRewardFun">
                <img src="@/assets/imgs/Xingji_shuangyi/tag_special.png" alt="">
                <div class="SpecialReward_Content">
                    <p>特别奖励进度：{{ TotalData.normalDrawCount % TotalData.specialInterval }} /
                        {{ TotalData.specialInterval }}</p>
                    <p>特别奖励次数：{{ TotalData.specialChanceAvailable }}</p>
                </div>
            </div>

            <!-- 抽取一次 -->
            <div class="ExtractOne public_btn">
                <img style="cursor: pointer;" @click="openHint(1)"
                    src="@/assets/imgs/Xingji_shuangyi/ExtractOne_btn.png" alt="">

            </div>

            <!-- 抽取十次 -->
            <div class="ExtractTen public_btn">
                <img style="cursor: pointer;" @click="openHint(10)"
                    src="@/assets/imgs/Xingji_shuangyi/ExtractTen_btn.png" alt="">

            </div>
            <!-- 剩余货币 -->
            <div class="CurrencySurplus public_btn" @click="$router.push('/recharge')">
                <img src="@/assets/imgs/Xingji_shuangyi/btn_recharge.png" alt="">
                <div class="CurrencySurplus_Content">
                    <p class="Surplus_num">星际币：{{ TotalData.drawCurrencyBalance }}</p>
                    <img class="GoRecharge" src="@/assets/imgs/Xingji_shuangyi/GoRecharge.png" alt="" srcset="">
                </div>
            </div>
        </div>

        <div class="show_Window" v-if="show_Window" @click="() => {
            openPageScroll()
            show_Window = false
        }">
            <div class="Content" @click.stop>
                <img v-if="show_Window_type == 'PrizePool'" class="Content_bg"
                    src="@/assets/imgs/Xingji_shuangyi/cmponent/bg1.png" alt="">
                <img v-else class="Content_bg" src="@/assets/imgs/Xingji_shuangyi/cmponent/bg.png" alt="">
                <!-- 规则 -->
                <div class="Content_body" v-if="show_Window_type == 'Rules'">
                    <div class="Content_body_Tit">
                        <img src="@/assets/imgs/Xingji_shuangyi/cmponent/Rules_tit.png" alt="规则说明tit">
                    </div>
                    <div class="Rules_body Content_body_public">
                        <div class="tit">活动时间：<span> 2026年8月31日—2026年9月13日24点</span></div>
                        <p>1.一个金龙元宝可以兑换一个星际币。</p>
                        <p>2.活动结束后，未曾使用的星际币、秘宝碎片将失效，请于活动截止前及时使用。</p>
                        <p>3.消耗星际币可抽取星际双翼秘宝并获得对应奖励，活动奖励请于网站商城—个人仓库查收。</p>
                        <p>4.抽取星际双翼秘宝有概率获得秘宝碎片，可用于在星际宝库中兑换珍稀道具。</p>
                        <p>5.除可重复获得奖励外，其余奖励仅会被抽取1次。</p>
                        <p>6.每40次开启秘宝，可额外抽取1次特殊奖励，必定获得一项特殊奖励。</p>
                        <p>7.初始概率公示：</p>
                        <div class="itm tindent">
                            <table>
                                <thead>
                                    <tr>
                                        <th>道具</th>
                                        <th>初始概率</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>卡册-红外钻地弹-终(36)</td>
                                        <td>0.15%</td>
                                    </tr>
                                    <tr>
                                        <td>卡册-滑动的里子盾-终(36)</td>
                                        <td>0.15%</td>
                                    </tr>
                                    <tr>
                                        <td>双十二 36星精品福袋</td>
                                        <td>0.5%</td>
                                    </tr>
                                    <tr>
                                        <td>2025年1期新宠福袋(绑定)</td>
                                        <td>0.5%</td>
                                    </tr>
                                    <tr>
                                        <td>赤色星际勤务官的箱子（绑定）</td>
                                        <td>1.85%</td>
                                    </tr>
                                    <tr>
                                        <td>水色星际勤务官的箱子（绑定）</td>
                                        <td>1.85%</td>
                                    </tr>
                                    <tr>
                                        <td>秘宝碎片 X3</td>
                                        <td>5%</td>
                                    </tr>
                                    <tr>
                                        <td>秘宝碎片 X2</td>
                                        <td>15%</td>
                                    </tr>
                                    <tr>
                                        <td>秘宝碎片 X1</td>
                                        <td>30%</td>
                                    </tr>
                                    <tr>
                                        <td>星际宝藏袋（绑定）</td>
                                        <td>45%</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <p>特殊抽奖概率公示：</p>
                        <div class="itm tindent">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>一等奖</td>
                                        <td>1%</td>
                                    </tr>
                                    <tr>
                                        <td>二等奖</td>
                                        <td>2%</td>
                                    </tr>
                                    <tr>
                                        <td>三等奖</td>
                                        <td>20%</td>
                                    </tr>
                                    <tr>
                                        <td>幸运奖</td>
                                        <td>77%</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <p>8.道具-星际宝藏袋获取概率：</p>
                        <div class="itm tindent">
                            <table>
                                <thead>
                                    <tr>
                                        <th>道具</th>
                                        <th>初始概率</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>七夕时空礼包 X1</td>
                                        <td>0.5%</td>
                                    </tr>
                                    <tr>
                                        <td>五阶天性强化果 x1</td>
                                        <td>14.5%</td>
                                    </tr>
                                    <tr>
                                        <td>外表重修果 x1</td>
                                        <td>15.0%</td>
                                    </tr>
                                    <tr>
                                        <td>完美卡片升级钻石 x30</td>
                                        <td>20.0%</td>
                                    </tr>
                                    <tr>
                                        <td>完美卡片升级宝石 x30</td>
                                        <td>20.0%</td>
                                    </tr>
                                    <tr>
                                        <td>六倍经验果 x5</td>
                                        <td>30.0%</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="Rules_btn Content_btn_public"></div>
                    <div class="Close" @click="() => {
                        openPageScroll()
                        show_Window = false
                    }">X</div>
                </div>
                <!-- 奖池 -->
                <div class="Content_body" v-if="show_Window_type == 'PrizePool'">
                    <div class="Content_body_Tit">
                        <img src="@/assets/imgs/Xingji_shuangyi/cmponent/Preview_tit.png" alt="奖池预览">
                    </div>
                    <div class="PrizePool_body Content_body_public">
                        <!-- 特殊奖励 -->
                        <div class="type_tit">普通奖池</div>

                        <div class="Special" v-for="num in 2" :key="num">
                            <div class="tit">{{ num == 1 ? '特殊奖励' : '可重复获得奖励' }}</div>
                            <div class="items">
                                <div class="it" v-for="value in PrizePoolList(num == 1 ? 1 : 0, 'Ordinary')"
                                    :key="value.prizeId">
                                    <el-tooltip class="item" effect="dark" :content="value.description" placement="top">
                                        <img :src="value.itemImg" alt="">
                                    </el-tooltip>

                                    <p>{{ value.itemName }} X {{ value.itemNum }}</p>
                                    <div v-if="value.obtained" class="Obtained">已获取</div>
                                </div>
                            </div>
                        </div>

                        <div class="type_tit">特别奖池</div>
                        <div class="Special" v-for="item in TotalData?.specialTiers" :key="item.tierCode">
                            <div class="tit" v-if="item.tierName=='幸运奖'">幸运奖（可重复领取奖励）</div>
                            <div class="tit" v-else>{{ item.tierName }}</div>
                            <div class="items">
                                <div class="it" v-for="value in PrizePoolList(item.tierCode, 'particularly')"
                                    :key="value.prizeId">
                                    <el-tooltip class="item" effect="dark" :content="value.description" placement="top">
                                        <img :src="value.itemImg" alt="">
                                    </el-tooltip>
                                    <p>{{ value.itemName }} X {{ value.itemNum }}</p>
                                    <div v-if="value.obtained" class="Obtained">已获取</div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="PrizePool_btn Content_btn_public">
                        <img @click="() => {
                            openPageScroll()
                            show_Window = false
                        }" src="@/assets/imgs/Xingji_shuangyi/cmponent/Sure_btn.png" alt="">
                    </div>

                </div>
                <!-- 记录 -->
                <div class="Content_body" v-if="show_Window_type == 'Record'">
                    <div class="Content_body_Tit">
                        <img src="@/assets/imgs/Xingji_shuangyi/cmponent/Record_tit.png" alt="获取记录">
                    </div>
                    <div class="Record_body Content_body_public">
                        <div class="Record_body_tit items">
                            <div>获取时间</div>
                            <div>奖励名称</div>
                        </div>
                        <div class="items" v-for="(value, index) in RecordList" :key="index">
                            <div>{{ new Date(value.addTime * 1000).toLocaleString('zh-CN', {
                                year: 'numeric', month: '2-digit', day: '2-digit',
                                hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
                            }) }}</div>
                            <div>{{ value.prizeStr }}</div>
                        </div>
                    </div>
                    <div class="Record_btn Content_btn_public">
                        <el-pagination background :hide-on-single-page="true" :page-size='10' :total="RecordTotal"
                            layout="prev, pager, next" @current-change="pagination_change">
                        </el-pagination>
                    </div>
                    <div class="Close" @click="() => {
                        openPageScroll()
                        show_Window = false
                    }">X</div>
                </div>
                <!-- 兑换 -->
                <div class="Content_body" v-if="show_Window_type == 'Exchange'">
                    <div class="Content_body_Tit Exchange_tit">
                        <img src="@/assets/imgs/Xingji_shuangyi/cmponent/Exchange_tit.png" alt="获取记录">
                        <div class="Currency">
                            <img src="@/assets/imgs/Xingji_shuangyi/CurrencySurplus.png" alt="">
                            <p class="Surplus_num">秘宝碎片：{{ TotalData.shopCurrencyBalance }}</p>
                        </div>
                    </div>
                    <div class="Exchange_body Content_body_public">
                        <div class="items">

                            <div :class="['it', ExchangeIndex == index ? 'Choose' : '']"
                                v-for="(value, index) in TotalData.shopItems" :key="value.itemId" @click="() => {
                                    ExchangeIndex = index
                                }">
                                <el-tooltip class="item" effect="dark" :content="value.description" placement="top">
                                    <img :src="value.itemImg" alt="">
                                </el-tooltip>
                                <p style="">{{ value.itemName }}</p>
                                <p class="price"><img src="@/assets/imgs/Xingji_shuangyi/Currency2.png" alt="">
                                    &nbsp; X
                                    {{
                                        value.price }}</p>
                                <p v-if="value.limitCount !== 0">({{ value.buyCount || 0 }}/{{ value.limitCount }})</p>
                            </div>
                        </div>
                    </div>
                    <div class="Exchange_btn Content_btn_public">
                        <img @click="() => {
                            openPageScroll()
                            show_Window = false
                        }" src="@/assets/imgs/Xingji_shuangyi/cmponent/Cancel_btn.png" alt="">
                        <img @click="Exchange_Sure" src="@/assets/imgs/Xingji_shuangyi/cmponent/Exchange_btn.png"
                            alt="">
                    </div>
                </div>
                <!-- 进阶奖励 -->
                <div class="Content_body" v-if="show_Window_type == 'Advanced'">
                    <div class="Content_body_Tit">
                        <img src="@/assets/imgs/Xingji_shuangyi/cmponent/Advanced_tit.png" alt="进阶奖励">
                    </div>
                    <div class="Advanced_body Content_body_public">
                        <div class="tit">
                            当前抽取次数：{{ TotalData.normalDrawCount }}
                        </div>
                        <div class="items">
                            <div class="it" v-for="value in TotalData.milestones" :key="value.itemId">
                                <div class="milestoneCount">累计抽取{{ value.drawCount }}次领取</div>
                                <div class="itemDesc">{{ value.itemName }}</div>
                                <el-tooltip class="item" effect="dark" :content="value.description" placement="top">
                                    <img :src="value.itemImg" alt="">
                                </el-tooltip>

                                <!-- <img src="@/assets/imgs/Xingji_shuangyi/coin.png" alt=""> -->
                                <img v-if="value.status === 0" style="filter: grayscale(100%);" @click="() => {
                                    $message.info('抽取次数不足')
                                }" src="@/assets/imgs/Xingji_shuangyi/cmponent/Claim_btn.png" alt="">
                                <img v-else-if="value.status === 1" @click="AdvancedFun(value.milestoneId)"
                                    src="@/assets/imgs/Xingji_shuangyi/cmponent/Claim_btn.png" alt="">
                                <img v-else-if="value.status === 2"
                                    src="@/assets/imgs/Xingji_shuangyi/cmponent/Collected.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="Close" @click="() => {
                        openPageScroll()
                        show_Window = false
                    }">X</div>
                </div>
                <!-- 抽取奖励 -->
                <div class="Content_body" v-if="show_Window_type == 'LotteryDraw'">
                    <div class="LotteryDraw_body Content_body_public">
                        <div class="item" v-for="(value, index) in LotteryDrawList" :key="index">
                            <img :src="value.itemImg" alt="">
                            <p>{{ value.itemName }}
                                <template>X{{ value.itemNum }}</template>
                            </p>
                        </div>

                    </div>
                    <div class="LotteryDraw_btn Content_btn_public" style="flex-wrap: wrap;">
                        <img v-if="!isSpecialReward" style="cursor: pointer; width: 150px;margin-right: 30px;"
                            @click="DirectLotteryDrawFun(1)" src="@/assets/imgs/Xingji_shuangyi/ExtractOne_btn.png"
                            alt="">
                        <img v-if="!isSpecialReward" style="cursor: pointer; width: 150px;margin-left: 30px;"
                            @click="DirectLotteryDrawFun(10)" src="@/assets/imgs/Xingji_shuangyi/ExtractTen_btn.png"
                            alt="">
                        <div style="width: 100%;text-align: center;">
                            <img @click="() => {
                                openPageScroll()
                                show_Window = false
                                isSpecialReward = false;
                                init()
                            }" src="@/assets/imgs/Xingji_shuangyi/cmponent/Sure_btn.png" alt="">
                        </div>
                    </div>
                </div>

                <!-- 兑换星际币 -->
                <div class="Content_body" v-if="show_Window_type == 'ExchangeLotteryCurrency'">

                    <div class="ExchangeLotteryCurrency_body Content_body_public">
                        <!-- 兑换提示 -->
                        <p class="hint">星际币不足，需要使用1个金龙元宝兑换1个星际币？</p>
                        <!-- <p class="hint" v-if="nextDrawCost">本次抽奖需<span>{{ nextDrawCost }}</span>个壮行酒</p> -->
                        <!-- 兑换图展示 -->
                        <div class="conversion_img">
                            <img src="@/assets/imgs/Xingji_shuangyi/coin.png" alt="">
                            <p>1:1</p>
                            <img src="@/assets/imgs/Xingji_shuangyi/Currency1.png" alt="">
                        </div>
                        <!-- 兑换 -->
                        <div class="conversion_input">
                            <span>兑换 :</span>
                            <input type="text" v-model="conversion_number">
                        </div>
                        <div class="ConfirmExchange">
                            <img @click="() => {
                                openPageScroll()
                                show_Window = false
                            }" src="@/assets/imgs/Xingji_shuangyi/cmponent/Cancel_btn.png" alt="">
                            <img @click="ExchangeLotteryCurrencyConfirmFun"
                                src="@/assets/imgs/Xingji_shuangyi/cmponent/Exchange_btn.png" alt="">
                        </div>

                        <div class="CurrencySurplus">
                            金龙元宝剩余：{{ userInfo?.wallteInfos?.[0]?.balance }}
                        </div>
                    </div>
                </div>
                <!-- 抽奖确认提示 -->
                <div class="Content_body" v-if="show_Window_type == 'LotteryDrawHint'">
                    <div class="LotteryDrawHint_body Content_body_public">
                        <p>确定抽奖吗</p>
                        <p>本次消耗：{{ drawType * 5 }}星际币</p>
                    </div>
                    <div class="Exchange_btn Content_btn_public">
                        <img @click="() => {
                            openPageScroll()
                            show_Window = false
                        }" src="@/assets/imgs/Xingji_shuangyi/cmponent/Cancel_btn.png" alt="">
                        <img @click="LotteryDrawFun" src="@/assets/imgs/Xingji_shuangyi/cmponent/Sure_btn.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import headerWX from "@/components/Header";
import Cookies from "js-cookie";
import { getMemberInfoApi } from "@/api/public.js";
// import {
//     getActivityInfoApi,
//     buyHiddenShopItemApi,
//     doLotteryApi,
//     exchangeApi,
//     getActivityLogApi,
//     claimMilestoneRewardApi
// } from "@/api/Xingji_shuangyi";
import {
    getInfoApi,               // 获取星际双翼秘宝活动信息
    buyHiddenShopItemApi,     // 使用秘宝碎片兑换商店道具
    doLotteryApi,             // 普通单抽或十连抽
    drawSpecialApi,           // 抽取特别奖励
    exchangeApi,              // 金龙元宝兑换星际币
    getActivityLogApi,        // 获取个人抽奖记录
    getRecentPrizeLogApi,     // 获取最近抽奖记录
    getShopListApi,           // 获取秘宝碎片商店列表
    claimMilestoneRewardApi   // 领取里程碑奖励（800或4800抽）
} from "@/api/Xingji_shuangyi";

const ACTIVITY_NAME = "202608_star_wing_treasure";
const PLATFORM = "web";

export default {
    name: "Xingji_shuangyi",

    components: {
        headerWX
    },

    data() {
        return {
            // 弹窗
            show_Window: false,
            show_Window_type: "",

            // 兑换
            ExchangeIndex: null,
            conversion_number: 1,

            // 抽奖结果
            LotteryDrawList: [],

            // 抽奖记录
            RecordTotal: 0,
            RecordList: [],

            // 用户信息
            userInfo: {},

            // 活动数据
            TotalData: {},

            // 当前抽奖类型：1 / 10
            drawType: null,

            isSpecialReward: false, // 是否为特别奖励
        };
    },

    computed: {
        /**
         * 根据 limitCount 过滤奖池
         * targetLimit = 1：特殊奖励
         * targetLimit = 0：可重复奖励
         */
        PrizePoolList() {
            return (targetLimit, type) => {
                let prizes = [];
                let keyName = '';

                if (type === 'Ordinary') {
                    prizes = Array.isArray(this.TotalData?.normalPrizes)
                        ? this.TotalData.normalPrizes
                        : [];
                    keyName = 'limitCount';
                } else if (type === 'particularly') {
                    prizes = Array.isArray(this.TotalData?.specialPrizes)
                        ? this.TotalData.specialPrizes
                        : [];
                    keyName = 'tierCode';
                }

                // 使用动态属性访问 [keyName] 进行筛选
                return prizes.filter(item => item && item[keyName] === targetLimit);
            };
        },

        userId() {
            return Cookies.get("cwsl_userId");
        },

        loveKeys() {
            return Number(this.TotalData?.shopCurrencyBalance || 0);
        },

        walletBalance() {
            return Number(this.userInfo?.wallteInfos?.[0]?.balance || 0);
        }
    },

    created() {
        this.init();
        this.getMemberInfo();
        this.openPageScroll();
    },

    beforeDestroy() {
        // 防止组件销毁后页面仍然处于禁止滚动状态
        this.openPageScroll();
    },

    methods: {
        /**
         * 统一关闭弹窗
         */
        closeWindow() {
            this.openPageScroll();
            this.show_Window = false;
            this.show_Window_type = "";
        },

        /**
         * 开启弹窗
         */
        openWindow(type) {
            this.closePageScroll();
            this.show_Window_type = type;
            this.show_Window = true;

            if (type === "Record") {
                this.RecordFun(1);
            }
        },

        /**
         * 通用接口响应判断
         */
        handleApiResponse(data, {
            success,
            errorMessage = ""
        } = {}) {
            if (data?.state === 200) {
                success?.(data);
                return true;
            }

            this.$message.info(data?.message || errorMessage || "操作失败");
            return false;
        },

        /**
         * 获取抽奖记录
         */
        async RecordFun(page = 1) {
            try {
                const { data } = await getActivityLogApi({
                    activityName: ACTIVITY_NAME,
                    page: page,
                    pageSize: 10,
                    userId: this.userId
                });

                this.handleApiResponse(data, {
                    success: (res) => {
                        this.RecordTotal = res.data?.total || 0;
                        this.RecordList = res.data?.list || [];
                    }
                });
            } catch (error) {
                this.$message.error(error?.message || "获取记录失败");
            }
        },

        /**
         * 记录分页
         */
        pagination_change(page) {
            this.RecordFun(page);
        },

        /**
         * 领取进阶奖励
         */
        async AdvancedFun(milestoneCount) {
            try {
                const { data } = await claimMilestoneRewardApi({
                    activityName: ACTIVITY_NAME,
                    milestoneId: milestoneCount,
                    userId: this.userId
                });

                this.handleApiResponse(data, {
                    success: (res) => {
                        this.$message.success(res.data?.message || "领取成功");
                        this.init();
                    }
                });
            } catch (error) {
                this.$message.error(error?.message || "领取失败");
            }
        },

        /**
         * 兑换商城道具
         */
        async Exchange_Sure() {
            if (this.ExchangeIndex === null) {
                this.$message.info("请选择所兑换的宝物！");
                return;
            }

            const item = this.TotalData?.shopItems?.[this.ExchangeIndex];

            if (!item) {
                this.$message.info("当前商品不存在，请刷新后重试");
                return;
            }

            const price = Number(item.price || 0);

            if (this.loveKeys < price) {
                this.$message.info("秘宝碎片碎片不足！");
                return;
            }

            try {
                const { data } = await buyHiddenShopItemApi({
                    activityName: ACTIVITY_NAME,
                    itemId: item.itemId,
                    themeId: item.themeId,
                    quantity: 1,
                    userId: this.userId
                });

                this.handleApiResponse(data, {
                    success: (res) => {
                        this.$message.success(res.data?.message || "兑换成功");
                        this.ExchangeIndex = null;
                        this.init();
                    }
                });
            } catch (error) {
                this.$message.error(error?.message || "兑换失败");
            }
        },

        /**
         * 兑换星际币
         */
        async ExchangeLotteryCurrencyConfirmFun() {
            const amount = Number(this.conversion_number);

            if (!Number.isInteger(amount) || amount <= 0) {
                this.$message.info("请输入正确的兑换数量");
                return;
            }

            if (amount > this.walletBalance) {
                this.$message.info("金龙元宝不足！");
                return;
            }

            try {
                const { data } = await exchangeApi({
                    activityName: ACTIVITY_NAME,
                    exchangeAmount: amount,
                    userId: this.userId
                });

                this.handleApiResponse(data, {
                    success: (res) => {
                        this.$message.success(res.data?.message || "兑换成功");
                        this.conversion_number = 1;
                        this.closeWindow();
                        this.init();
                        this.getMemberInfo();
                    }
                });

            } catch (error) {
                this.$message.error(error?.message || "兑换失败");
            }
        },

        /**
         * 点击抽奖按钮后的余额检查
         */
        openHint(type) {
            if (![1, 10].includes(type)) return;

            this.drawType = type;
            const cost = type * 5;

            if (this.TotalData.drawCurrencyBalance < cost) {
                this.openWindow("ExchangeLotteryCurrency");
                return;
            }

            this.openWindow("LotteryDrawHint");
        },
        // 特别奖励抽取
        SpecialRewardFun() {
            if (this.TotalData.specialChanceAvailable < 1) {
                this.$message.info("特别奖励次数不足！");
                return;
            }
            const loading = this.$loading({
                text: "抽取中...",
                background: "rgba(0, 0, 0, 0.7)"
            });
            this.isSpecialReward = true;
            drawSpecialApi({
                activityName: ACTIVITY_NAME,
                userId: this.userId
            }).then((res) => {
                if (res.data.state == 200) {
                    this.LotteryDrawList = [res.data.data?.prize] || [];
                    this.openWindow("LotteryDraw");
                    this.getMemberInfo();
                    this.init();
                    this.$message.success(`恭喜您抽中${res.data.data?.tierName || "未知奖励"}！`);

                } else {
                    this.$message.error(res.data.message);
                }
            }).finally(() => {
                loading.close();

            })
        },

        /**
         * 确认抽奖
         */
        async LotteryDrawFun() {
            if (![1, 10].includes(this.drawType)) {
                this.$message.info("抽奖类型错误");
                return;
            }

            await this.doLottery(this.drawType, true);
        },

        /**
         * 抽奖结果弹窗中的再次抽奖
         */
        DirectLotteryDrawFun(type) {
            if (![1, 10].includes(type)) return;

            const cost = type * 5;

            if (this.TotalData.drawCurrencyBalance < cost) {
                this.openWindow("ExchangeLotteryCurrency");
                return;
            }

            this.doLottery(type, false);
        },

        /**
         * 统一抽奖请求
         *
         * showResult = true 时，抽奖后打开结果弹窗。
         */
        async doLottery(type, showResult = true) {
            try {
                const loading = this.$loading({
                    text: "抽奖中...",
                    background: "rgba(0, 0, 0, 0.7)"
                });

                const { data } = await doLotteryApi({
                    activityName: ACTIVITY_NAME,
                    drawType: type,
                    userId: this.userId
                });

                if (data?.state === 200) {
                    this.LotteryDrawList = data.data?.prizes || [];
                    this.drawType = null;

                    if (showResult) {
                        this.openWindow("LotteryDraw");
                    }

                    this.getMemberInfo();
                    this.init();
                } else {
                    this.$message.error(data?.message || "抽奖失败");
                }
                loading.close();

            } catch (error) {
                this.$message.error(error?.message || "抽奖失败");
                loading.close();
            }
        },

        /**
         * 获取用户信息
         */
        async getMemberInfo() {
            try {
                const { data } = await getMemberInfoApi({
                    userId: this.userId,
                    platForm: PLATFORM
                });

                if (data?.state === 200) {
                    this.userInfo = data.data || {};
                    this.resetSetItem("userInfo", JSON.stringify(this.userInfo));
                } else {
                    this.$message.error("获取信息失败,请重试");
                }
            } catch (error) {
                this.$message.error(error?.message || "获取用户信息失败");
            }
        },

        /**
         * 初始化活动数据
         */
        async init() {
            try {
                const { data } = await getInfoApi({
                    activityName: ACTIVITY_NAME,
                    userId: this.userId,
                    platForm: PLATFORM
                });

                if (data?.state === 200) {
                    this.TotalData = data.data || {};
                } else {
                    this.$message.info(data?.message || "获取活动数据失败");
                }

                // await getShopListApi({
                //     activityName: ACTIVITY_NAME,
                //      platForm: PLATFORM,
                //     userId: this.userId
                // })
            } catch (error) {
                this.$message.error(error?.message || "获取活动数据失败");
            }
        },

        /**
         * 禁止页面滚动
         */
        closePageScroll() {
            document.body.style.overflow = "hidden";
            document.documentElement.style.overflow = "hidden";
        },

        /**
         * 恢复页面滚动
         */
        openPageScroll() {
            document.body.style.overflow = "";
            document.documentElement.style.overflow = "";
        }
    }
};
</script>

<style>
body {
    background-image: linear-gradient(to bottom, #343e44 0%, #5d666f 50%, #4e4541 100%) !important;
}
</style>

<style lang="less" scoped>
.Xingji_shuangyi {
    position: relative;
    min-width: 1200px;
    max-width: 2000px;
    margin: auto;

    .bg {
        width: 100%;
    }

    .headerWX {
        width: 100%;
        transform: scale(0.8);
        position: absolute;
        top: 3%;
    }

    .Xingji_shuangyi_Content {
        position: absolute;
        top: 14%;
        left: 50%;
        transform: translateX(-50%);
        width: 80%;
        height: 85%;

        .tit {
            text-align: center;

            >img {
                max-width: 20%;
            }
        }

        .public_btn {
            position: absolute;

            >img {
                max-width: 100%;
            }
        }

        .Exchange {
            left: 10%;
            width: 10%;
        }

        .Advanced {
            top: 25%;
            left: 10%;
            width: 10%;
        }

        .Rules {
            right: 10%;
            width: 10%;
        }

        .PrizePool {
            right: 10%;
            top: 25%;
            width: 10%;
        }

        .Record {
            right: 10%;
            top: 39%;
            width: 10%;
        }

        // 特别奖励
        .SpecialReward {
            bottom: 24%;
            left: 50%;
            transform: translateX(-50%);
            width: 30%;
            cursor: pointer;
            user-select: none;

            .SpecialReward_Content {
                position: absolute;
                top: 50%;
                left: 64%;
                transform: translate(-50%, -50%);
                width: 63%;
                height: 54%;
                display: flex;
                gap: 8px;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                z-index: 2;

                p {
                    color: #ffffff;
                    font-weight: 600;
                    font-size: 17px;

                    text-shadow:
                        0 0 5px #fff,
                        0 0 10px #8b8fdc;
                }
            }
        }

        .Activate {

            // 灯光效果
            &::before {
                content: "";
                position: absolute;
                left: 50%;
                top: 50%;
                width: 120%;
                height: 120%;
                transform: translate(-50%, -50%);
                border-radius: 50%;
                background: rgba(255, 220, 120, 0.5);
                filter: blur(25px);
                z-index: 0;
                pointer-events: none;

                animation: specialRewardGlow 1.8s ease-in-out infinite;
            }

            >img {
                position: relative;
                z-index: 1;

                // 奖励本身发光
                filter:
                    drop-shadow(0 0 5px rgba(255, 255, 255, 0.9)) drop-shadow(0 0 12px rgba(255, 220, 100, 0.9));

                animation: specialRewardBreath 1.8s ease-in-out infinite;
            }
        }

        // 呼吸效果
        @keyframes specialRewardBreath {

            0%,
            100% {
                transform: scale(1);
                filter:
                    drop-shadow(0 0 5px rgba(255, 255, 255, 0.8)) drop-shadow(0 0 10px rgba(255, 220, 100, 0.7));
            }

            50% {
                transform: scale(1.06);
                filter:
                    drop-shadow(0 0 8px rgba(255, 255, 255, 1)) drop-shadow(0 0 20px rgba(255, 220, 100, 1)) drop-shadow(0 0 30px rgba(255, 190, 50, 0.8));
            }
        }


        // 外部灯光呼吸
        @keyframes specialRewardGlow {

            0%,
            100% {
                opacity: 0.35;
                transform: translate(-50%, -50%) scale(0.85);
            }

            50% {
                opacity: 0.8;
                transform: translate(-50%, -50%) scale(1.15);
            }
        }

        // 抽取一次
        .ExtractOne {
            bottom: 13%;
            left: 32%;
            width: 15%;
            display: flex;
            gap: 5px;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            p {
                font-size: 14px;
                display: flex;
                gap: 8px;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-weight: 700;
                text-shadow:
                    -1px -1px 0 #000,
                    1px -1px 0 #000,
                    -1px 1px 0 #000,
                    1px 1px 0 #000;

                >img {
                    width: 20%;
                }
            }
        }

        .ExtractTen {
            bottom: 13%;
            right: 32%;
            width: 15%;
            display: flex;
            gap: 5px;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            p {
                font-size: 14px;
                display: flex;
                gap: 8px;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-weight: 700;
                text-shadow:
                    -1px -1px 0 #000,
                    1px -1px 0 #000,
                    -1px 1px 0 #000,
                    1px 1px 0 #000;

                >img {
                    width: 20%;
                }
            }
        }

        .CurrencySurplus {
            bottom: 3%;
            right: 42%;
            width: 15%;
            cursor: pointer;

            >img {
                width: 100%;
            }

            .CurrencySurplus_Content {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                height: 73%;
                width: 80%;

                .Surplus_num {
                    text-align: center;
                    color: #ffffff;
                    font-weight: 600;
                    font-size: 17px;
                    text-shadow: 0 0 4px #8b8fdc, 0 0 8px #8b8fdc, 0 0 12px #8b8fdc;
                }

                .GoRecharge {
                    width: 50%;
                }
            }

        }
    }

    .show_Window {
        position: fixed;
        top: 0%;
        left: 50%;
        transform: translateX(-50%);
        background-color: rgba(95, 94, 92, 0.527);
        z-index: 1000;
        width: 100vw;
        height: 100vh;
        backdrop-filter: blur(12px);

        .Content {
            position: absolute;
            top: 45%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 800px;
            height: fit-content;

            .Content_bg {
                width: 100%;
            }

            .Content_body {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 95%;
                height: 90%;

                .Close {
                    position: absolute;
                    right: 20px;
                    top: 20px;
                    width: 30px;
                    height: 30px;
                    border: 2px solid #fff;
                    border-radius: 50%;
                    line-height: 30px;
                    text-align: center;
                    font-size: 20px;
                    color: #fff;
                    cursor: pointer;
                }

                .Content_body_Tit {
                    width: 100%;
                    margin-top: 2%;
                    text-align: center;

                    >img {
                        width: 15%;
                    }
                }

                //兑换
                .Exchange_tit {
                    text-align: center;
                    position: relative;

                    .Currency {
                        position: absolute;
                        top: 0;
                        right: 5%;
                        width: 18%;
                        height: 100%;

                        >img {
                            width: 100%;
                            height: 100%;
                        }

                        p {
                            width: 95%;
                            position: absolute;
                            top: 53%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            font-size: 12px;
                            color: #ffffff;
                            font-weight: 700;
                            text-shadow:
                                0 0 4px #8b8fdc,
                                0 0 8px #8b8fdc,
                                0 0 12px #8b8fdc;

                        }
                    }
                }

                // 公用
                .Content_body_public {
                    width: 100%;
                    height: 75%;
                    // background-color: #00ff5586;
                }

                .Content_btn_public {
                    height: 10%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                //规则
                .Rules_body {
                    height: 78%;
                    overflow: auto;
                    padding-top: 10px;

                    .tit {
                        font-size: 24px;
                        text-align: center;
                        color: #fff;

                        >span {
                            color: rgb(255, 255, 255);
                            font-size: 24px;
                            font-weight: 600;
                            text-shadow: -1px -1px 0 #8b8fdc, 1px -1px 0 #8b8fdc, -1px 1px 0 #8b8fdc, 1px 1px 0 #8b8fdc;
                        }
                    }

                    >p {
                        text-indent: 2em;
                        font-size: 18px;
                        line-height: 32px;
                        width: 80%;
                        margin: auto;
                        color: #fff;
                    }

                    .itm {
                        line-height: 30px;
                        color: #ffffff;
                        font-size: 18px;

                        span {
                            font-size: 20px;
                        }

                        table {
                            width: 500px;
                            border-collapse: collapse;
                            margin: 20px auto;
                        }

                        table,
                        th,
                        td {
                            border: 1px solid #82673e;
                        }

                        th,
                        td {
                            text-align: center;
                            padding: 8px;
                        }
                    }
                }

                // 奖池
                .PrizePool_body {
                    height: 82%;
                    overflow: auto;

                    .type_tit {
                        position: relative;
                        //   display: inline-block;
                        text-align: center;
                        margin: 15px 0;
                        font-size: 18px;
                        font-weight: 800;
                        letter-spacing: 3px;
                        /* 实现文字颜色的金色渐变 */
                        background: linear-gradient(180deg, #ffe082 0%, #d4af37 50%, #8c6d1f 100%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                        padding-bottom: 6px;
                    }

                    /* 底部金色渐变下划线及其中间高亮点 */
                    .type_tit::after {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 100%;
                        height: 2px;
                        background: linear-gradient(90deg, transparent, #d4af37 50%, transparent);
                    }

                    .tit {
                        width: 99%;
                        text-align: center;
                        line-height: 30px;
                        background-color: #ffffff79;
                        color: #fff;
                        font-weight: 700;
                        font-size: 18px;
                        margin: auto;
                        border-radius: 10px;
                    }

                    .Special {
                        display: flex;
                        gap: 30px;
                        flex-direction: column;

                        .items {
                            flex: 1;
                            display: flex;
                            flex-wrap: wrap;
                            gap: 10px 7%;
                            justify-content: center;
                            align-items: flex-end;

                            .it {
                                width: 130px;
                                height: 120px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                flex-direction: column;
                                gap: 20px;
                                color: #fff;
                                background-color: #ffffff79;
                                border-radius: 10px;
                                margin-bottom: 10px;
                                position: relative;

                                >img {
                                    max-width: 50px;
                                }

                                >p {
                                    width: 100%;
                                    text-align: center;
                                    text-wrap: wrap;
                                    text-shadow: 0 0 4px #8b8fdc, 0 0 8px #8b8fdc, 0 0 12px #8b8fdc;

                                }

                                .Obtained {
                                    position: absolute;
                                    top: 50%;
                                    width: 100%;
                                    background-color: #04030291;
                                    color: #dba16e;
                                    text-align: center;
                                    padding: 10px 0;
                                    transform: translateY(-50%);
                                    font-weight: 700;
                                }
                            }
                        }
                    }

                    .Ordinary {
                        // height: 40%;

                        .items {
                            margin-top: 25px;
                            display: flex;
                            flex-wrap: wrap;
                            gap: 10px 6%;
                            justify-content: center;
                            align-items: flex-end;

                            .item {
                                width: 130px;
                                height: 120px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                flex-direction: column;
                                gap: 15px;
                                color: #fff;
                                background-color: #ffffff79;
                                border-radius: 10px;

                                >img {
                                    max-width: 80%;
                                    max-height: 64%;
                                    object-fit: cover;
                                }

                                >p {
                                    width: 100%;
                                    text-align: center;
                                    text-wrap: nowrap;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                    text-shadow: 0 0 4px #8b8fdc, 0 0 8px #8b8fdc, 0 0 12px #8b8fdc;

                                }
                            }
                        }
                    }
                }

                //记录
                .Record_body {
                    width: 100%;
                    margin: auto;
                    color: #fff;

                    .Record_body_tit {
                        >div {
                            font-size: 20px;
                            font-weight: 700;
                        }
                    }

                    .items {
                        width: 100%;
                        display: flex;

                        >div {
                            flex: 1;
                            text-align: center;
                            margin: 7px;
                        }
                    }
                }


                //兑换
                .Exchange_body {
                    height: 74%;

                    .items {
                        height: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        gap: 0 5%;
                        justify-content: center;
                        align-items: center;


                        .it {
                            padding: 5px 10px;
                            width: 18%;
                            height: 130px;
                            display: flex;
                            justify-content: space-around;
                            align-items: center;
                            flex-direction: column;
                            gap: 8px;
                            color: #fff;
                            background-color: #ffffff79;
                            border-radius: 10px;
                            cursor: pointer;

                            >img {
                                width: 50px;
                                height: 50px;
                            }

                            >p {
                                width: 100%;
                                white-space: wrap;
                                text-align: center;
                                font-size: smaller;
                                text-shadow: 0 0 4px #8b8fdc, 0 0 8px #8b8fdc, 0 0 12px #8b8fdc;
                            }

                            .price {
                                display: flex;
                                align-items: center;
                                justify-content: center;

                                >img {
                                    width: 30px;

                                }
                            }
                        }

                        .Choose {
                            border-color: #00f7ff;
                            box-shadow: 0 0 10px #00f7ff, 0 0 20px #00f7ff, 0 0 30px #00f7ff;
                            animation: pulse-border 0.6s ease-out;
                        }

                        @keyframes pulse-border {
                            0% {
                                box-shadow: 0 0 0 0 rgba(0, 247, 255, 0.7);
                            }

                            70% {
                                box-shadow: 0 0 0 12px rgba(5, 114, 117, 0.418);
                            }

                            100% {
                                box-shadow: 0 0 0 0 rgba(2, 233, 241, 0.979);
                            }
                        }
                    }
                }

                .Exchange_btn {

                    gap: 12%;

                    >img {
                        width: 10%;
                        cursor: pointer;
                    }
                }

                //进阶奖励
                .Advanced_body {
                    display: flex;
                    flex-direction: column;

                    .tit {
                        width: 100%;
                        line-height: 30px;
                        color: #fff;
                        text-align: center;
                    }

                    .items {
                        flex: 1;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-around;

                        .it {
                            width: 180px;
                            height: 250px;
                            background-color: #ffffff77;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-direction: column;
                            gap: 10px;
                            border-radius: 20px;

                            .milestoneCount {
                                color: #fff;
                                font-size: 14px;
                                font-weight: 700;
                            }

                            .itemDesc {
                                color: #fff;
                                font-size: 17px;
                                font-weight: 700;
                                text-align: center;
                            }

                        }
                    }
                }


                //抽取奖励
                .LotteryDraw_body {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 40px;
                    justify-content: center;
                    align-content: center;

                    .item {
                        width: 110px;
                        height: 120px;
                        background-color: #ffffff69;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                        gap: 10px;
                        border-radius: 10px;

                        >img {
                            width: 60px;
                        }

                        >p {
                            width: 100%;
                            text-align: center;
                            color: #fff;
                        }
                    }
                }

                // 兑换星际币
                .ExchangeLotteryCurrency_body {
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    align-items: center;

                    .hint {
                        font-size: 20px;
                        color: #fff;
                        font-weight: 700;
                    }

                    .conversion_img {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 20px 0;

                        >img {
                            // width: 100px;
                            max-height: 80px;
                        }

                        >p {
                            font-size: 50px;
                            font-weight: 600;
                            margin: 0 50px;
                            color: #d2d07b;
                            font-family: Verdana, Geneva, Tahoma, sans-serif;
                        }
                    }

                    .conversion_input {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: relative;
                        left: -5%;

                        span {
                            font-size: 24px;
                            margin-right: 30px;
                            color: #fff;
                            font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;

                        }

                        input {
                            line-height: 40px;
                            border-radius: 20px;
                            text-align: center;
                            font-size: 20px;
                            background-color: #c6492e;
                            color: #fff;
                            border: 1px solid #fff;
                        }

                        input:focus {
                            outline: 2px solid #fce18d;
                            border: 1px solid #fce18d;

                            /* 获得焦点时显示绿色轮廓 */
                        }

                    }

                    .ConfirmExchange {
                        margin: 30px 0;
                        text-align: center;

                        >img {
                            margin: 0 20px;
                        }
                    }

                    .CurrencySurplus {
                        padding: 20px;
                        background-color: #ffffff75;
                        border-radius: 20px;
                        font-size: 20px;
                        color: #fff;
                        font-weight: 700;
                    }
                }

                //抽奖确认提示
                .LotteryDrawHint_body {
                    display: flex;
                    justify-content: center;
                    flex-direction: column;

                    >p {
                        text-align: center;
                        color: #fff;
                        font-size: 24px;
                        padding-bottom: 20px;
                    }
                }
            }
        }
    }
}
</style>